import { ToastOptions } from 'react-hot-toast';
import { getToast } from './getToast';

export interface GWToastOptions extends ToastOptions {
  wrapperClassName?: string;
  toastId?: string;
  showbackdrop?: boolean;
  visible?: boolean;
}

const toast = {
  info: (message: string, options?: GWToastOptions) => getToast(message, 'info', options),
  success: (message: string, options?: GWToastOptions) => getToast(message, 'success', options),
  warning: (message: string | React.JSX.Element, options?: GWToastOptions) => getToast(message, 'warning', options),
  error: (message: string, options?: GWToastOptions) => getToast(message, 'error', options),
};

export default toast;
